var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8C9.24546 8 9.44961 8.17688 9.49194 8.41012L9.5 8.5V12.293L10.1464 11.6464L10.2157 11.5886C10.4106 11.4536 10.68 11.4729 10.8536 11.6464C11.0271 11.82 11.0464 12.0894 10.9114 12.2843L10.8536 12.3536L9.35355 13.8536L9.28431 13.9114C9.1138 14.0295 8.8862 14.0295 8.71569 13.9114L8.64645 13.8536L7.14645 12.3536L7.08859 12.2843C6.97047 12.1138 6.97047 11.8862 7.08859 11.7157L7.14645 11.6464L7.21569 11.5886C7.3862 11.4705 7.6138 11.4705 7.78431 11.5886L7.85355 11.6464L8.5 12.293V8.5C8.5 8.22386 8.72386 8 9 8ZM7.46541 0C9.81058 0 11.7615 1.76641 12.0898 4.07933L12.106 4.218L12.1885 4.26217C13.2325 4.8544 13.9242 5.95598 13.9942 7.19674L14 7.40476C14 9.32531 12.5479 10.8923 10.6933 10.9947L10.5 11V10C11.8859 10 13 8.84682 13 7.40476C13 6.34278 12.3741 5.40195 11.4375 5.00479C11.2611 4.93002 11.143 4.7611 11.1333 4.56982C11.0318 2.57136 9.41906 1 7.46541 1C5.58465 1 4.00966 2.45946 3.81343 4.36794C3.78857 4.60975 3.59339 4.79865 3.35089 4.81559C2.03399 4.90757 1 6.03572 1 7.40476C1 8.78317 2.0443 9.90681 3.3594 9.99449L3.52515 10H7.5V11H3.52515C1.57567 11 0 9.38783 0 7.40476C0 5.70979 1.1547 4.2746 2.72297 3.90295L2.876 3.87L2.88278 3.83341C3.29679 1.7059 5.09048 0.106069 7.24843 0.00506804L7.46541 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.03030df6434680b2df53ecc1ea73d22b.svg";
export { ForwardRef as ReactComponent };